import axios from "axios";
import {
  notRequiredAndText,
  requiredAndText,
  requiredAndTextMd,
  requiredIfNot,
  validarAfinazoneId,
  validarBool,
  validarLitrosYPrecios,
  validateNumberNotRequired,
  validatePrice,
  validateUPC
} from "helpers/validators";
const API_BASE_URL = `${process.env.REACT_APP_LARAVEL_API_HOST}/api`;
const TOKEN = process.env.REACT_APP_LARAVEL_API_TOKEN;

const LABELS_KAT = {
  0: "afinazone_id",
  1: "titulo",
  2: "transmision",
  3: "tipo_producto",
  4: "marca_aceite",
  5: "variantes_aceite",
  6: "marca_auto",
  7: "modelo_auto",
  8: "anios_modelo",
  9: "volumen_cilindros",
  10: "cantidad_cilindros",
  11: "detalle_cilindros",
  12: "productos",
  13: "filtro_1",
  14: "filtro_2",
  15: "junta",
  16: "o_ring",
  18: "precio",
  25: "introduccion",
  26: "contenido",
  27: "adicional",
  28: "compatibilidad",
  29: "final",
  30: "portada",
  31: "complemento_1",
  32: "complemento_2",
  33: "fluido_aceite",
  34: "sticker",
  35: "codigo_upc",
  36: "folleto",
  37: "deshabilitar_aceite",
  38: "stock",
  39: "producto_recomendado",
  40: "variante_recomendada",
  41: "revision",
};


const FIELD_VALIDATORS = {
  afinazone_id: (value) => validarAfinazoneId(value),
  titulo: (value) => requiredAndText(value, 'titulo'),
  transmision: (value) => requiredAndText(value, 'transmisión'),
  tipo_producto: (value) => requiredAndText(value, 'tipo de producto'),
  marca_aceite: (value, condition) => requiredIfNot(value, condition, 'marca aceite'),
  variantes_aceite: (value, condition) => requiredIfNot(value, condition, 'variantes aceite'),

  marca_auto: (value) => requiredAndText(value, 'marca auto'),
  modelo_auto: (value) => requiredAndText(value, 'modelo auto'),
  anios_modelo: (value) => requiredAndText(value, 'años modelo'),

  volumen_cilindros: (value) => requiredAndText(value, 'volumen cilindros'),
  cantidad_cilindros: (value) => requiredAndText(value, 'cantidad cilindros'),
  detalle_cilindros: (value) => notRequiredAndText(value),

  productos: (value) => requiredAndText(value, 'productos'),
  filtro_1: (value, condition) => requiredIfNot(value, condition, 'filtro 1', 'KA'),
  filtro_2: (value) => notRequiredAndText(value),
  junta: (value) => notRequiredAndText(value, 'junta'),
  o_ring: (value) => notRequiredAndText(value),
  precio: (value) => validatePrice(value),

  introduccion: (value) => requiredAndTextMd(value, 'introducción'),
  contenido: (value) => requiredAndTextMd(value, 'contenido'),
  adicional: (value) => requiredAndTextMd(value, 'adicional'),
  compatibilidad: (value) => requiredAndTextMd(value, 'compatibilidad'),
  final: (value) => requiredAndTextMd(value, 'final'),

  portada: (value) => requiredAndText(value, 'portada'),
  complemento_1: (value) => requiredAndText(value, 'complemento 1'),
  complemento_2: (value) => requiredAndText(value, 'complemento 2'),
  fluido_aceite: (value, condition) => requiredIfNot(value, condition, 'fluido aceite'),
  sticker: (value) => requiredAndText(value, 'sticker'),
  codigo_upc: (value) => validateUPC(value),

  folleto: (value) => validarBool(value),
  deshabilitar_aceite: (value) => validarBool(value),
  stock: (value) => validarBool(value),
  producto_recomendado: (value) => validarBool(value),

  variante_recomendada: (value) => validateNumberNotRequired(value),
  revision: (value) => validarBool(value),
};



export async function uploadNewKatItems(data) {
  const errors = {};
  const validItems = [];

  data.forEach(item => {
    const afinazone_id = item[0];

    // Ignorar items sin ID válido
    if (afinazone_id === undefined || afinazone_id === null || afinazone_id === "") {
      return; // Saltar a la siguiente iteración
    }

    const result = createBody(item);

    if (!result.success) {
      if (!errors[afinazone_id]) errors[afinazone_id] = [];
      errors[afinazone_id].push(...result.errors);
    } else {
      validItems.push(result.body);
    }
  });

  if (Object.keys(errors).length > 0) {
    return {
      success: false,
      error: errors,
      message: "Errores de validación encontrados"
    };
  }
  try {
    const response = await axios.post(
      `${API_BASE_URL}/afinazone/kat/bulk`,
      { items: validItems },
      {
        timeout: 60000,
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      }
    );

    console.log("✅ Items subidos con éxito:", response.data);
    return { success: true, data: response.data };
  } catch (error) {
    if (error.code === "ECONNABORTED") {
      console.error("⏳ Timeout: La solicitud tardó demasiado y fue cancelada");
      return { success: false, error: "Timeout: La solicitud tardó demasiado" };
    }

    console.error(
      "❌ Error en la subida:",
      error.response?.data || error.message
    );
    return { success: false, error: error.response?.data || error.message };
  }
}

function createBody(data) {

  if (data[0] === undefined || data[0] === "") return null;

  const body = {};
  const errors = [];

  // Validar cada campo
  for (const [index, value] of data.entries()) {
    const label = LABELS_KAT[index];
    if (!label) continue; // Si no existe el label, lo saltamos

    const validator = FIELD_VALIDATORS[label];
    if (!validator) {
      body[label] = value; // Si no hay validador, se asigna el valor crudo
      continue;
    }

    const result = validator(value, data[3]);
    if (!result.valid) {
      errors.push({
        label,
        value,
        message: result.error
      });
    } else {
      body[label] = result.value;
    }
  }

  body['litros'] = null;
  if (data[3] !== 'KF') {
    const result = validarLitrosYPrecios(data, 17, 23);
    if (!result.valid) {
      errors.push({
        label: 'litros',
        message: result.error
      });
    } else {
      body['litros'] = result.value;
    }
  }

  return {
    success: errors.length === 0,
    body: errors.length === 0 ? body : null,
    errors: errors.length > 0 ? errors : null
  };
}
